import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpUtils} from '../shared/http.utils';
import {DefaultMeasurementTypeFilters} from "../model/filters/default-measurement-type-filters";
import {DefaultMeasurementTypePersistRequest} from "../model/requests/default-measurement-type-persist-request";

@Injectable({
  providedIn: 'root'
})
export class DefaultMeasurementTypesService {

  private readonly defaultMeasurementTypesURL: string;

  constructor(private http: HttpClient) {
    this.defaultMeasurementTypesURL = '/catalog/default_measurement_types';
  }

  public getDefaultMeasurementTypes(offset?: number, limit?: number, filters?: DefaultMeasurementTypeFilters): Observable<any> {
    const options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    const body = (filters != null) ? filters : new DefaultMeasurementTypeFilters();
    return this.http.post<any>(this.defaultMeasurementTypesURL, body, options);
  }

  public getDefaultMeasurementType(sensor: string, unit: string): Observable<any> {
    const url = `${this.defaultMeasurementTypesURL}/${sensor}/${unit}`;
    return this.http.get<any>(url);
  }

  public createDefaultMeasurementType(defaultMeasurementTypePersistRequest: DefaultMeasurementTypePersistRequest): Observable<void> {
    const url = `${this.defaultMeasurementTypesURL}/create`;
    return this.http.post<void>(url, defaultMeasurementTypePersistRequest);
  }

  public editDefaultMeasurementType(defaultMeasurementTypePersistRequest: DefaultMeasurementTypePersistRequest): Observable<void> {
    const url = `${this.defaultMeasurementTypesURL}/edit`;
    return this.http.post<void>(url, defaultMeasurementTypePersistRequest);
  }

  public deleteDefaultMeasurementType(sensor: string, unit: string): Observable<HttpResponse<any>> {
    const url = `${this.defaultMeasurementTypesURL}/${sensor}/${unit}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteDefaultMeasurementTypes(identifiers: { sensor: string, unit: string }[]): Observable<void> {
    const url = `${this.defaultMeasurementTypesURL}/delete`;
    return this.http.post<void>(url, identifiers);
  }
}
